<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter>
                    <template #before>
                        <span>{{ data?.before.dividendKindText }}</span>
                    </template>
                    <template #after>
                        <span>{{ data?.after.dividendKindText }}</span>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';

export default {
    name: 'B2Data',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('B2');
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, removeService };
    },
};
</script>
